export default "__VITE_ASSET__BF$AEPzA__"